export default __webpack_public_path__ + "static/media/chatbox.e93fae1b.svg";